exports.default = {
  'projects': '項目',
  'search_document': '搜尋頁面...',
  'create_project': '建立項目',
  'new_project': '建立項目',
  'recently_visited': '最近瀏覽',
  'no_recent_visits': '暫無最近訪問記錄',
  'all_projects': '所有項目',
  'no_projects_created': '您還沒創建項目',
  'no_conversation_history': '暫無對話歷史',
  'edit': '編輯',
  'new_page': '建立頁面',
  'project_name': '項目名稱',
  'project_name_placeholder': '請輸入項目名稱',
  'project_description': '項目描述',
  'project_description_placeholder': '請輸入項目描述',
  'project_cover': '項目封面',
  'project_name_max_length': '項目名稱最長為50個字',
  'cover_preview': '封面預覽',
  'input_title': '請輸入標題',
  'all': '全部',
  'color': '色彩',
  'document_belongs_to': '文檔歸屬於',
  'work': '辦公',
  'technology': '科技',
  'no_access_content': '建立第一個頁面',
  'scenery': '風景',
  'random_cover': '隨機封面',
  'random_cover_success': '已隨機選擇封面',
  'project_name_error': '項目名稱輸入不正確，無法刪除',
  'upload_cover': '上傳封面',
  'dark': '暗',
  'light': '亮',
  'no_conversation': '您還未與任何智能體進行會話',
  'upload_success': '封面上傳成功',
  'delete_project': '刪除項目',
  'development_tool': '研發工具使用',
  'delete_warning': '警告：刪除當前項目及其所有頁面，此操作無法復原。',
  'confirm_by_name': '請輸入項目名稱以確認刪除：',
  'delete_success': '刪除成功',
  'name_incorrect': '項目名稱輸入不正確，無法刪除',
  'add_failed': '新增失敗',
  'edit_failed': '修改失敗',
  'create_copy': '建立副本',
  'copy_name_placeholder': '請輸入副本名稱',
  'add_doc_placeholder': '請輸入文檔名稱',
  'search_project': '搜尋項目',
  'cancel': '取 消',
  'add_as_copy': '添加為副本',
  'unnamed_doc': '未命名',
  'add_success': '添加成功',
  'get_recent_list_failed': '獲取最近訪問列表失敗',
  'search': '搜索',
  'catalog': '目錄',
  'new_document': '新建文檔',
  'new_web_page': '新建網頁',
  'add_doc_to': '新建到',
  'default_move_to': '從當前項目移動到',
  'import_document': '導入文檔',
  'add_group': '新建文檔',
  'recently_modified': '最後修改',
  'download': '下載',
  'copy_success': '複製成功',
  'copy_failed': '複製失敗，請稍後重試！',
  'operation_failed': '操作失敗，請稍後重試',
  'modify_failed': '修改失敗',
  'untitled_document': '未命名文檔',
  'untitled_webpage': '未命名網頁',
  'delete_file_title': '是否刪除：{filename}',
  'delete_file_warning': '刪除後將無法恢復此頁面。請謹慎操作！',
  'delete_document_confirmation': '刪除當前文檔，請謹慎操作。',
  'delete_document': '刪除文檔',
  'confirm': '確定',
  'executing': '執行中...',
  'close': '關 閉',
  'cannot_move_tooltip': '不支持移動到原位置或子項下',
  'group_name_placeholder': '請輸入組名稱',
  'create_document': '新建文檔',
  'rename': '重新命名',
  'move': '移動',
  'delete': '刪除',
  'sidebar_tooltip': '側邊欄',
  'prev_page_tooltip': '上一頁',
  'next_page_tooltip': '下一頁',
  'zoom_out_tooltip': '縮小',
  'zoom_in_tooltip': '放大',
  'download_tooltip': '下載',
  'quote': '引用',
  'rewrite': '改寫',
  'rewrite_beautify': '潤色美化',
  'rewrite_simple': '精簡語言',
  'rewrite_expand': '擴展豐富',
  'rewrite_popular': '通俗處理',
  'explain': '解釋',
  'summary': '總結',
  'translate': '翻譯',
  'translate_zh_cn': '中文',
  'translate_en_us': '英語',
  'translate_ja': '日語',
  'translate_ko': '韓語',
  'translate_fr': '法語',
  'translate_de': '德語',
  'loading_image': '正在加載圖片',
  'find': '查找',
  'find_in_file_placeholder': '在文件裡查找',
  'analyze': '解讀',
  'add_to_chat': '添加到聊天框',
  'esc_to_exit_tooltip': '可按ESC鍵退出',
  'rewrite_request_content': '請將【{content}】潤色語言優美一些',
  'rewrite_simple_request_content': '請將【{content}】改寫精簡一些',
  'rewrite_expand_request_content': '請將【{content}】改寫擴展豐富一些',
  'rewrite_popular_request_content': '請將【{content}】改寫的通俗易懂',
  'explain_request_content': '請解釋【{content}】',
  'summary_request_content': '請總結【{content}】',
  'translate_zh_request_content': '請將【{content}】翻譯成中文',
  'translate_en_request_content': '請將【{content}】翻譯成英語',
  'translate_ja_request_content': '請將【{content}】翻譯成日語',
  'translate_ko_request_content': '請將【{content}】翻譯成韓語',
  'translate_fr_request_content': '請將【{content}】翻譯成法語',
  'translate_de_request_content': '請將【{content}】翻譯成德語',
  'sync_success': '離線資料已同步到伺服器',
  'sync_failed': '資料同步失敗，已保存到本地快取',
  'network_disconnected': '網路斷開，文檔已保存到本地快取',
  'cache_restored': '快取資料已恢復',
  'unsync_cache_detected': '檢測到您有未同步的本地快取資料，是否要恢復？',
  'abandon': '放棄',
  'restore': '恢復',
  'doc_not_exist': '文檔不存在',
  'no_permission': '您沒有此頁面的權限',
  'project_deleted': ' 項目已被刪除',
  'document_deleted': ' 文檔已被刪除',
  'page_width_setting': '頁寬設置',
  'select_width': '為當前窗口選擇合適頁寬',
  'wide': '較寬',
  'full_wide': '全寬',
  'default': '默認',
  'find_and_replace': '查找和替換',
  'move_to': '移動到',
  'download_doc_as': '下載為',
  'toc': '本篇目錄',
  'no_toc_found': '目錄為空',
  'locating': '查找',
  'replace': '替換',
  'replace_with': '替換爲',
  'search_in_doc': '在文檔內查找',
  'enter_text': '請輸入文字',
  'replace_all': '全部替換',
  'previous': '上一處',
  'next': '下一處',
  'confirm_delete_scope': '請確認刪除範圍',
  'delete_only_this_page': '僅刪除此頁面',
  'delete_page_with_children': '刪除此頁面和它包含的所有子頁面',
  'exporting_wait_finish': '請先等待目前文件匯出完成',
  'exporting_in_progress': '正在匯出...',
  'exporting_completed': '匯出完成！',
  'exporting_failed_colon': '匯出失敗：',
  'exporting_error_occurred_colon': '匯出過程出錯：',
  'export_pdf_generating': '正在產生 PDF，請稍候（最長約 2 分鐘）…',
  'export_pdf_failed': 'PDF 匯出失敗',
  'export_pdf_no_permission': '沒有權限匯出該文件',
  'export_pdf_empty_doc': '文件內容為空，無法匯出',
  'export_pdf_busy': '匯出服務繁忙，請稍後再試',
  'export_pdf_fallback_confirm': '伺服器匯出失敗，是否改用瀏覽器列印匯出？',
  'export_pdf_use_browser_print': '使用瀏覽器列印',
  'access_scope': '項目權限',
  'access_private': '僅自己可見',
  'access_team_read': '團隊唯讀',
  'access_team_edit': '團隊可編輯'
}
